document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('page pathway');

  if (run.length > 0) {
    const endpoint = document.location.href;
    const csrfToken = document.querySelector("[name='csrf-token']").content;

    fetch(endpoint, { method: 'POST', headers: { 'X-CSRF-Token': csrfToken } }).then((response) => {
      if (response.ok) {
        document.location.href = '/';
      }
    }).catch((error) => {
      console.log(error);
    });
  }
});
    
